import {logger} from '@/modules/common/logging/logger';

import {PlayMode} from '../store/usePlayStore';
import {IFleetTrackerPlaybackService} from './IFleetTrackerPlaybackService';

export class FleetTrackerPlaybackServiceLogDecorator implements IFleetTrackerPlaybackService {
  private decoree: IFleetTrackerPlaybackService;

  constructor(decoree: IFleetTrackerPlaybackService) {
    this.decoree = decoree;
  }

  initializePlayback(startTime: Date, endTime: Date | undefined): void {
    const start = this.logStart('initializePlayback');
    this.decoree.initializePlayback(startTime, endTime);
    this.logEnd('initializePlayback', start);
  }

  // Not logged: called on every FleetTracker time tick
  updateCurrentTime(currentTime: Date): void {
    this.decoree.updateCurrentTime(currentTime);
  }

  cancelPendingCurrentTimeUpdate(): void {
    const start = this.logStart('cancelPendingCurrentTimeUpdate');
    this.decoree.cancelPendingCurrentTimeUpdate();
    this.logEnd('cancelPendingCurrentTimeUpdate', start);
  }

  changePlayMode(mode: PlayMode, playing: boolean, speed: number): void {
    const methodName = `changePlayMode -> ${PlayMode[mode]} -> playing: ${playing} -> speed: ${speed}`;
    const start = this.logStart(methodName);
    this.decoree.changePlayMode(mode, playing, speed);
    this.logEnd(methodName, start);
  }

  setPlay(playing: boolean): void {
    const start = this.logStart(`setPlay -> ${playing}`);
    this.decoree.setPlay(playing);
    this.logEnd(`setPlay -> ${playing}`, start);
  }

  setSpeed(speed: number): void {
    const start = this.logStart(`setSpeed -> ${speed}`);
    this.decoree.setSpeed(speed);
    this.logEnd(`setSpeed -> ${speed}`, start);
  }

  seek(time: Date): void {
    const start = this.logStart(`seek -> ${time.getTime()}`);
    this.decoree.seek(time);
    this.logEnd(`seek -> ${time.getTime()}`, start);
  }

  private logStart(methodName: string): number {
    const start: number = performance.now();
    logger.info(`Start -> ${methodName}`);
    return start;
  }

  private logEnd(methodName: string, start: number): void {
    const duration = performance.now() - start;
    logger.info(`End -> ${methodName} (${duration.toFixed(2)}ms)`);
  }
}
